<template>
    <div class="public_container bad_debt_wrap" v-loading="formLoading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                ref="badDebtForm"
                class="custom_mobile_form"
            >
                <van-field
                    v-model="order_detail.total_price"
                    name="total_price"
                    label="订单总金额"
                    placeholder="自动带出"
                    readonly
                    disabled
                >
                </van-field>
                <van-field
                    v-model="order_detail.total_repay_price"
                    name="total_repay_price"
                    label="已回款总金额"
                    placeholder="自动带出"
                    readonly
                    disabled
                >
                </van-field>
                <van-field
                    v-model="order_detail.no_repay_price"
                    name="no_repay_price"
                    label="未回款金额"
                    placeholder="自动带出"
                    readonly
                    disabled
                >
                </van-field>
                <van-field
                    v-model="badDebtForm.bad_debt_amount"
                    name="bad_debt_amount"
                    label="坏账金额"
                    placeholder="自动带出"
                    readonly
                    disabled
                >
                </van-field>
                <van-field
                    required
                    v-model="badDebtForm.operate_time"
                    name="operate_time"
                    label="操作时间"
                    placeholder="请选择"
                    readonly
                    is-link
                    @click="handleClickSelectPayTime"
                    :rules="[{ required: true, message: '请选择' }]"
                >
                </van-field>
                <van-field
                    v-model="badDebtForm.remark"
                    name="remark"
                    label="备注"
                    placeholder="请输入"
                    rows="4"
                    maxlength="200"
                    autosize
                    type="textarea"
                    input-align="left"
                    class="vertical_input_wrap"
                >
                </van-field>
                <van-field name="attachment" label="附件" class="vertical_input_wrap">
                    <template #input>
                        <div class="upload_input_wrap">
                            <ul class="voucher_list">
                                <li :key="index" class="voucher_item" v-for="(item, index) in badDebtForm.attachment">
                                    <van-image :src="item" alt=""> </van-image>
                                    <i
                                        @click="badDebtForm.attachment.splice(index, 1)"
                                        class="iconfont icon-guanbi_dise"
                                    ></i>
                                </li>
                                <li @click="handleClickUploadFile" class="upload_img_wrap">
                                    <i class="el-icon-plus"></i>
                                </li>
                            </ul>
                            <p class="hint">请上传银行交易凭证截图（建议大小不超过5M，支持png、jpg等格式）</p>
                        </div>
                    </template>
                </van-field>
            </van-form>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
        <!-- 选择时间 -->
        <van-popup
            :style="{ height: '352px' }"
            round
            position="bottom"
            v-if="showDatePopupShow"
            v-model="showDatePopupShow"
        >
            <van-datetime-picker
                v-model="currentTime"
                type="datetime"
                title="选择时间"
                @cancel="showDatePopupShow = false"
                @confirm="handleDateCalenderConfirm"
                :min-date="dateCalendarMin"
                :max-date="dateCalendarMax"
            />
        </van-popup>
    </div>
</template>
<script>
import { OrderMarkBadDebt } from "@/api";
import { uploadImg } from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "BadDebt",
    components: { ReturnNavBar },
    data() {
        return {
            formLoading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            order_num: "",
            order_detail: {},
            badDebtForm: {
                order_num: "",
                bad_debt_amount: "",
                operate_time: "",
                remark: "",
                attachment: [],
            },
            showDatePopupShow: false,
            currentTime: "",
            dateCalendarMin: new Date("2015-01-01"),
            dateCalendarMax: new Date("2070-01-01"),
            btnDisabled: false,
        };
    },
    created() {
        if (this.$route.query) {
            this.order_num = this.$route.query.order_num;
            this.order_detail = this.$route.query.order_detail;
            this.badDebtForm.bad_debt_amount = this.order_detail.no_repay_price;
        }
    },
    methods: {
        // 选择时间
        handleClickSelectPayTime() {
            this.showDatePopupShow = true;
        },
        //点击日期选择器确定事件
        handleDateCalenderConfirm(date) {
            this.showDatePopupShow = false;
            this.badDebtForm.operate_time = this.formatDate(date, "datetime");
        },
        formatDate(dateString, date_type) {
            // 创建日期对象
            const dateObj = new Date(dateString);
            // 获取年、月、日
            const year = dateObj.getFullYear();
            const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
            const day = ("0" + dateObj.getDate()).slice(-2);
            const hours = ("0" + dateObj.getHours()).slice(-2);
            const minutes = ("0" + dateObj.getMinutes()).slice(-2);
            const seconds = ("0" + dateObj.getSeconds()).slice(-2);
            let formattedDateTime = "";
            if (date_type === "date") {
                formattedDateTime = year + "-" + month + "-" + day;
            } else if (date_type === "year-month") {
                formattedDateTime = year + "-" + month;
            } else if (date_type === "datetime") {
                formattedDateTime = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
            }
            return formattedDateTime;
        },
        // 上传图片
        handleClickUploadFile() {
            const input = document.createElement("input");
            input.setAttribute("type", "file");
            input.setAttribute("accept", "image/png,image/jpeg,image/gif,image/jpg");
            input.setAttribute("multiple", "multiple");
            input.click();
            const that = this;
            input.onchange = function () {
                const files = Array.from(this.files);
                if (files.some((file) => file.size > 5 * 1024 * 1024)) return that.$toast("图片大小不允许超过5m");
                if (that.badDebtForm.attachment.length + files.length > 5) return that.$toast("最多只能上传5张");
                files.forEach((file) => {
                    uploadImg(file)
                        .then((res) => {
                            that.badDebtForm.attachment.push(res.file_path);
                        })
                        .catch(() => {
                            return false;
                        });
                });
            };
        },
        handleClickConfirm() {
            this.$refs.badDebtForm.validate().then(() => {
                const params = {
                    order_num: this.order_num,
                    bad_debt_amount: this.badDebtForm.bad_debt_amount,
                    operate_time: this.badDebtForm.operate_time,
                    remark: this.badDebtForm.remark,
                    attachment: this.badDebtForm.attachment,
                };
                this.btnDisabled = true;
                this.formLoading = true;
                OrderMarkBadDebt(params)
                    .then((res) => {
                        if (res.code === 200) {
                            this.btnDisabled = false;
                            this.formLoading = false;
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    this.$router.go(-1);
                                },
                            });
                        } else {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        }
                    })
                    .catch(() => {
                        this.btnDisabled = false;
                        this.formLoading = false;
                    });
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.bad_debt_wrap {
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: rgba(247, 248, 250, 1);

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}

</style>
